import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-brand">
          <strong>Gorty's Tech, LLC</strong>
          <p>
            .NET, mobile, and single-page apps, IdentityServer and OAuth 2.0,
            store releases, Azure CI/CD and scaling, and database management.
          </p>
        </div>
        <div className="lp-footer-links">
          <Link to="/">Home</Link>
          <Link to="/request-services">Request Services</Link>
          <Link to="/sms-opt-in">SMS Opt-In</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms &amp; Conditions</Link>
        </div>
      </div>
      <p className="lp-footer-fineprint">
        © {currentYear} Gorty's Tech, LLC. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
